export class globalData {
    user_id: any;
    userId: any;
    email: any;
    account_id: any;
    account_name: any;
    accountName: any;
    role: any;
    user_name: any;
    company_name: any;
    category: any;
}
